import React from "react";
import Case from "../../../../models/Case";
import CompleteCase from "../../../../models/CompleteCase";
import CaseType from "../../../../models/CaseType";
import ColumnRenderer from "../../../app/Table/renderer/ColumnRenderer";
import constants from "../../../../common/constants";
import { Button, Modal, Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import Reminder from "../../../../models/Reminder";
import LocalStorage from "../../../../lib/LocalStorage";
import axios from "axios";
import { toast } from "../../../common/Toast";
import config from "../../../../common/repository/config";
import Remarks from "../CaseViewPage/Remarks";
import Reminders from "../CaseViewPage/Reminders/Reminders";
import CaseReminders from "../CaseViewPage/Reminders/CaseReminders";

export default class CaseColumnRenderer extends ColumnRenderer {
  //if view type is false, it will return remainder, available tat fields along with case else return final remark,
  // closure tat, allocation delay along with case
  private viewType: boolean = false;
  updateModel: any;

  constructor(viewType?: boolean | undefined, updateModel?: any) {
    super();

    if (viewType) this.viewType = viewType;
    this.updateModel = updateModel;
  }

  private hasInstruction = (row: any): boolean => {
    const inst = row.getInstruction ? row.getInstruction() : (row.instruction ?? null);
    if (!inst) return false;
    if (Array.isArray(inst)) return inst.length > 0;
    if (typeof inst === "object") return Object.keys(inst).length > 0;
    if (typeof inst === "string") return inst.trim().length > 0;
    return false;
  };

  // private runningTatHours = (row: any): number => {
  //   try {
  //     let hrs = 0;
  //     if (row.getReinvestigation() === false) {
  //       const inwardDate = new Date(row.getInwardDateTime());
  //       const now = new Date();
  //       hrs = this.calculateHours(inwardDate, now);
  //     } else {
  //       const tatTiming = row.getTatTiming() || [];
  //       tatTiming.forEach((e: any) => {
  //         const start = new Date(e.start_time);
  //         const end = e.close_time ? new Date(e.close_time) : new Date();
  //         hrs += this.calculateHours(start, end);
  //       });
  //     }
  //     return hrs;
  //   } catch (err) {
  //     return 0;
  //   }
  // };

  fun = async (caseId: string) => {
    toast.success("Please wait, while we are collecting data.");
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    const response = await axios({
      url: config.apiBaseURL + `/download`,
      method: "POST",
      responseType: "blob",
      data: {
        action: "case",
        data: [caseId],
      },
      headers: { ["x-access-token"]: token },
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "CaseRecord.zip");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

   calculateHours(startDate: Date, endDate: Date) {
    // body...

    // Store minutes worked
    let minutesWorked = 0;

    // Validate input
    if (endDate < startDate) {
      return 0;
    }

    // Loop from your Start to End dates (by hour)
    let current = startDate;

    // Define work range
    let workHoursStart = 9;
    let workHoursEnd = 18;
    let includeWeekends = false;

    // Loop while currentDate is less than end Date (by minutes)
    while (current <= endDate) {
      // Is the current time within a work day (and if it
      // occurs on a weekend or not)
      if (
        current.getHours() >= workHoursStart &&
        current.getHours() < workHoursEnd &&
        (includeWeekends
          ? current.getDay() !== 0 && current.getDay() !== 6
          : true)
      ) {
        minutesWorked++;
      }

      // Increment current time
      current.setTime(current.getTime() + 1000 * 60);
    }
    // minutesWorked--

    // Return the number of hours
    // console.log(minutesWorked)
    //if(hrs>)
    return Math.round(minutesWorked / 60);
  }



  getColumns = () => {
    if (this.viewType)
      return [
        {
          name: "Case Category",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) return row.getCategory().getTitle();
          },
        },
        {
          name: "Case Type",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) return row.getType().getTitle();
          },
        },
        {
          name: "Closure TAT",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) {
              let inwardDate = new Date(row.getInwardDateTime());
              let closeDate = new Date(row.getClosedOn()!);
              let hrs = this.calculateHours(inwardDate, closeDate);
              let avTAT = "";
              let days = Math.floor(hrs / 9);
              let hours = hrs % 9;
              if (days > 1) avTAT = `${days} Days `;
              else if (days == 1) avTAT = `${days} Day `;
              if (hours > 0) avTAT += `${hours} Hours`;
              return avTAT;
            }
          },
        },
        {
          name: "Claim Number",
          selector: "claimNumber",
        },
        {
          name: "TPA/Company Name",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) {
              const tpa = row.getTPA();
              const company = row.getInsuranceCompany();
              const companyName = row.getInsuranceCompanyName();
              if (tpa !== null) return tpa.getName();
              else if (company !== null) return company.getName();
              else if (companyName !== null) return companyName;
              return "";
            }
          },
        },
        {
          name: "Insured Name",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getInsuredName();
          },
        },
        {
          name: "Insured District",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case)
              return row.getInsuredLocation()?.getDistrict();
          },
        },
        {
          name: "Hospital",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getHospital().getName();
          },
        },
        {
          name: "Outcome",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getOutcome();
          },
        },
        {
          name: "Actions",
          selector: "id",
          width: "120px",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) {
              const state = row.getState();
              const id = row.getId();
              const code = row.getCategory().getCode();

              let buttonText: string = "";
              let buttonColor: string = "";
              if (state === constants.caseStates.generated) {
                buttonText = "Allocate";
                buttonColor = "#ffe75e";
              } else if (state === constants.caseStates.open) {
                buttonText = "Open";
                buttonColor = "#deff8b";
              }
              else if (state === constants.caseStates.reinvestigate) {
                buttonText = "Reinvestigate";
                buttonColor = "#deff8b";
              }
              else if (state === constants.caseStates.fold) {
                buttonText = "Perform QC";
                buttonColor = "#ff6f5e";
              } else if (state === constants.caseStates.checked) {
                buttonText = "P. Closure";
                buttonColor = "#f0134d";
              } else if (state === constants.caseStates.close) {
                buttonText = "P. Grading";
                buttonColor = "#d1f5d3";
              } else {
                buttonText = "Closed";
                if (row.getIsWithdrawed() == true) buttonColor = "#cd5c5c";
              }

              return (
                <Button
                  as={Link}
                  style={{ width: 150, backgroundColor: buttonColor }}
                  to={{
                    pathname: `/case/view/${id}`,
                    state: `/case/list?category=${code}&state=${state}`,
                  }}
                >
                  {buttonText}
                </Button>
              );
            } else if (row instanceof Case) {
              return (
                <Button
                  style={{ width: 150 }}
                  primary
                  as={Link}
                  to={`/case/generate/${row.getId()}`}
                >
                  Generate
                </Button>
              );
            }
          },
        },
        {
          name: "Actions",
          selector: "id",
          width: "100px",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) {
              const id = row.getId();

              return (
                <Button
                  style={{
                    width: 90,
                    marginLeft: "-10px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                  onClick={(_, { value }) => this.fun(id)}
                >
                  Download
                </Button>
              );
            } else if (row instanceof Case) {
              const id = row.getId();
              return (
                <Button
                  style={{
                    width: 90,
                    marginLeft: "-10px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                  onClick={(_, { value }) => this.fun(id)}
                >
                  Download
                </Button>
              );
            }
          },
        },
      ];
    else
      return [
        {
          name: "Reminder",
          width: "80px",
          selector: "id",
          grow: 0,
          cell: (row: {}) => {
            if (row instanceof CompleteCase) {
              const reminders = row.getReminders();
              if (reminders.length === 0) return null;

              let reminder: Reminder | null = null;
              reminders.forEach((r) => {
                if (!r.getActive()) return;

                if (reminder === null) {
                  reminder = r;
                } else if (r.getRemainingTime() < reminder.getRemainingTime()) {
                  reminder = r;
                }
              });
              if (reminder === null) return null;

              let backgroundColor = "green";
              let textColor = "#222";
              const time = reminder!.getRemainingTime();
              if (time < 18000) {
                backgroundColor = "red";
                textColor = "white";
              } else if (time < 54000) {
                backgroundColor = "yellow";
              }

              return (
                <Popup
                  basic
                  position="top center"
                  trigger={
                    <div
                      style={{
                        width: 70,
                        height: 20,
                        borderRadius: 2,
                        opacity: 0.8,
                        background: backgroundColor,
                        cursor: "pointer",
                        color: textColor,
                        fontSize: 9,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {reminder!.getValidUpto()}
                    </div>
                  }
                >
                  <Popup.Content>
                    <div>{reminder!.getText()}</div>
                    <div>@ {reminder!.getValidUpto()}</div>
                  </Popup.Content>
                </Popup>
              );
            }
          },
        },
        {
          name: "Case Type",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) return row.getType().getTitle();
          },
        },

      
        {
          name: "Running TAT",
          selector: "id",
          cell: (row: any) => {
            if (row instanceof Case) {
              let hrs = 0;
              let avTAT = "";
          
              if (row.getReinvestigation() === false) {
                let inwardDate = new Date(row.getInwardDateTime());
                let closeDate = new Date();
                hrs = this.calculateHours(inwardDate, closeDate);
              } else {
                let tatTiming = row.getTatTiming();
                tatTiming.forEach((e: any) => {
                  let inwardDate = new Date(e.start_time);
                  let closeDate = e.close_time ? new Date(e.close_time) : new Date();
                  hrs += this.calculateHours(inwardDate, closeDate);
                });
              }
          
              const inwardDate = new Date(row.getInwardDateTime());
              const today = new Date();

              const inward = new Date(
                  inwardDate.getFullYear(),
                  inwardDate.getMonth(),
                  inwardDate.getDate()
              );

              const current = new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate()
              );

              const days = Math.floor(
                  (current.getTime() - inward.getTime()) / (1000 * 60 * 60 * 24)
              );
              let hours = hrs % 9;
              if (days > 1) avTAT = `${days} Days `;
              else if (days === 1) avTAT = `${days} Day `;
              if (hours > 0 && row.getCategory().getCode() !== constants.UDI.CaseCategory.code.LTI) {
                avTAT = `${days +1} Days `;
              }
              if (row.getCategory().getCode() === constants.UDI.CaseCategory.code.LTI) {
                if (hours > 0) avTAT += `${hours} Hours`;
              }

          
              return avTAT;
            }
            return null;
          },
          sortable: true,
          sortFunction: (a: any, b: any) => {
            const extractHours = (tat: string | null | undefined) => {
              if (!tat || typeof tat !== 'string') return 0;
              const daysMatch = tat.match(/(\d+)\s*Days?/i);
              const hoursMatch = tat.match(/(\d+)\s*Hours?/i);
              const days = daysMatch ? parseInt(daysMatch[1], 10) * 9 : 0;
              const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
            
              return days + hours; 
            };
            const aTat = a?.["Running TAT"] || ""; 
            const bTat = b?.["Running TAT"] || ""; 

            const aHours = extractHours(aTat);
            const bHours = extractHours(bTat);
            
            console.log(`Sorting: a=${aTat} (${aHours} hrs), b=${bTat} (${bHours} hrs)`);
            return aHours - bHours;
          }
          
        },
        {
          name: "Re-Investigation TAT",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) {
              if (row.getReinvestigation() === false) {
                return "N/A"
              } else {
                let tatTiming = row.getTatTiming();
                let hrs = 0;
                tatTiming.forEach((e: any, i: number) => {
                  if (i > 0) {
                    let inwardDate = new Date(e.start_time);
                    let closeDate = e.close_time ? new Date(e.close_time) : new Date();
                    hrs += this.calculateHours(inwardDate, closeDate);
                  }
                });

                let avTAT = "";
                let days = Math.floor(hrs / 9);
                let hours = hrs % 9;
                if (days > 1) avTAT = `${days} Days `;
                else if (days == 1) avTAT = `${days} Day `;
                if (hours > 0) avTAT += `${hours} Hours`;
                return avTAT;
              }
            }
          },
        },
        {
          name: "Instruction",
          selector: "id",
          sortable: true,
          
          cell: (row: any) => {
            const instructions = row.getInstruction ? row.getInstruction() : (row.instruction ?? null);
            if (Array.isArray(instructions) && instructions.length > 0) {
              return (
                <div style={{ backgroundColor: "red", color: "white", padding: "4px" }}>
                  {instructions.map((inst: any) => (
                    <div key={inst.getId ? inst.getId() : Math.random()}>
                      {inst.instructionType ?? inst}
                    </div>
                  ))}
                </div>
              );
            }
            if (instructions && typeof instructions === "object") {
              return (
                <div style={{ padding: "4px" }}>
                  {(instructions as any).instructionType ?? "—"}
                </div>
              );
            }
            return "—";
          },
        },
        // {
        //   name: "Instruction",
        //   selector: "id",
        //   sortable: true,
        //   sortFunction: (a: any, b: any) => {
        //     // Priority 1: Sort cases with instructions first
        //     const aHas = this.hasInstruction(a) ? 0 : 1;
        //     const bHas = this.hasInstruction(b) ? 0 : 1;
        //     if (aHas !== bHas) return aHas - bHas;

        //     // Priority 2: If both are in the same instruction group, sort by running TAT
        //     return this.runningTatHours(a) - this.runningTatHours(b);
        //   },
        //   cell: (row: any) => {
        //     const instructions = row.getInstruction ? row.getInstruction() : (row.instruction ?? null);
        //     if (Array.isArray(instructions) && instructions.length > 0) {
        //       return (
        //         <div style={{ backgroundColor: "red", color: "white", padding: "4px" }}>
        //           {instructions.map((inst: any) => (
        //             <div key={inst.getId ? inst.getId() : Math.random()}>
        //               {inst.instructionType ?? inst}
        //             </div>
        //           ))}
        //         </div>
        //       );
        //     }
        //     if (instructions && typeof instructions === "object") {
        //       return (
        //         <div style={{ backgroundColor: "red", color: "white", padding: "4px" }}>
        //           {(instructions as any).instructionType ?? "—"}
        //         </div>
        //       );
        //     }
        //     return "—";
        //   },
        // },
        {
          name: "Claim Number",
          selector: "claimNumber",
        },
        {
          name: "TPA/Company Name",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) {
              const tpa = row.getTPA();
              const company = row.getInsuranceCompany();
              const companyName = row.getInsuranceCompanyName();
              if (tpa !== null) return tpa.getName();
              else if (company !== null) return company.getName();
              else if (companyName !== null) return companyName;
              return "";
            }
          },
        },
        {
          name: "Insured Name",
          selector: "id",
          style: {
            wordBreak: "break-word",
            overflowWrap: "break-word",
          },
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getInsuredName();
          },
        },
        {
          name: "Insured District",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof Case) {
              return row.getInsuredLocation()
                ? row.getInsuredLocation()?.getDistrict()
                : "";
            }
          },
        },
        {
          name: "Hospital",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getHospital()?.getName() || "";
          },
        },
        {
          name: "Hospital State",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getHospital()?.getState() || "";
          },
        },
        {
          name: "Hospital District",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getHospital()?.getDistrict() || "";
          },
        },
        {
          name: "Hospital State",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getHospital().getState();
          },
        },
        {
          name: "Hospital District",
          selector: "id",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) return row.getHospital().getDistrict();
          },
        },
        {
          name: "Actions",
          selector: "id",
          width: "120px",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) {
              const state = row.getState();
              const id = row.getId();
              const code = row.getCategory().getCode();

              let buttonText: string = "";
              let buttonColor: string = "";
              let marginValue: string = "";
              if (state === constants.caseStates.generated) {
                buttonText = "Allocate";
                buttonColor = "#ffe75e";
                marginValue = "Opx";
              } else if (state === constants.caseStates.open) {
                buttonText = "Open";
                buttonColor = "#deff8b";
                marginValue = "Opx";
              } else if (state === constants.caseStates.reinvestigate) {
                buttonText = "Reinvestigate";
                buttonColor = "#deff8b";
                marginValue = "0px";
              }
              else if (state === constants.caseStates.fold) {
                buttonText = "Perform QC";
                buttonColor = "#ff6f5e";
                marginValue = "5px";
              }
              else if (state === constants.caseStates.report) {
                buttonText = "Report Writing";
                buttonColor = "#deff8b";
                marginValue = "5px";
              }
              else if (state === constants.caseStates.pushbackCA) {
                buttonText = "Investigate";
                buttonColor = "#deff8b";
                marginValue = "5px";
              }
              else if (state === constants.caseStates.checked) {
                buttonText = "P. Closure";
                buttonColor = "#f0134d";
                marginValue = "5px";
              } else if (state === constants.caseStates.close) {
                buttonText = "P. Grading";
                buttonColor = "#d1f5d3";
                marginValue = "5px";
              } else {
                buttonText = "Report";
                if (row.getIsWithdrawed() == true) buttonColor = "#cd5c5c";
              }

              return (
                <Button
                  as={Link}
                  style={{ width: 150, backgroundColor: buttonColor, margin: marginValue }}
                  to={{
                    pathname: `/case/view/${id}`,
                    state: `/case/list?category=${code}&state=${state}`,
                  }}
                >
                  {buttonText}
                </Button>
              );
            } else if (row instanceof Case) {
              return (
                <Button
                  style={{ width: 150 }}
                  primary
                  as={Link}
                  to={`/case/generate/${row.getId()}`}
                >
                  Generate
                </Button>
              );
            }
          },
        },
        {
          name: "Actions",
          selector: "id",
          width: "220px",
          cell: (row: {}) => {
            if (row instanceof CompleteCase) {
              const id = row.getId();

              return (
                <div style={{ display: "flex", gap: "8px" }}>
                  <Button
                    style={{
                      width: 90,
                      marginLeft: "-10px",
                      paddingLeft: "0px",
                      paddingRight: "0px",
                    }}
                    onClick={() => this.fun(id)}
                  >
                    Download
                  </Button>
                  <Modal
                    size="small"
                    closeIcon
                    style={{
                      width: "80%",
                      maxWidth: "80%",
                      margin: "0 auto",
                    }}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                    trigger={
                      <Button
                        style={{
                          width: 90,
                          paddingLeft: "0px",
                          paddingRight: "0px",
                        }}
                      >
                        Action
                      </Button>
                    }
                  >
                    <Modal.Header>Case Instructions</Modal.Header>
                    <Modal.Content>
                      <CaseReminders model={row} updateModel={this.updateModel} />
                    </Modal.Content>
                  </Modal>
                </div>
              );
            } else if (row instanceof Case) {
              const id = row.getId();

              return (
                <Button
                  style={{
                    width: 90,
                    marginLeft: "-10px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                  onClick={() => this.fun(id)}
                >
                  Download
                </Button>
              );
            }
          },
        }
      ];
  };
}